import { getCurrentSensorTestPicture, getSensorDetail, testCameraConnect, updateCameraIntrinsic, updateSensor } from "@/api/device/sensor"
import { DEVICE_TYPE } from "@/enums/device-type"
import { TAB_TYPE } from "@/enums/tab-type"
import TnInput from "@/global/components/input/tn-input"
import TnMessage from "@/global/components/message"
import { CameraTest, Sensor } from "@/global/interface/device/sensor"
import { Button, Image, Input, Modal, Select, Switch, message } from "antd"
import classNames from "classnames"
import { useState, useEffect, useRef } from "react"
import { TabRoute } from "tncet-common"
import DeviceParamItem from "../param-item"
import { useParams } from "react-router-dom"
import { ReactComponent as EditSvg } from '../icons/edit.svg';

import "./index.less"
import dayjs from "dayjs"
import { SENSOR_TYPE } from "@/enums/sensor-type"

const SensorStatus = {
    OFF: 0,     // 离线
    ON: 1,      // 正常
    ERROR: 2    // 异常
}

interface Iprops {
    data: Sensor
    setData: (e) => void
}

const EditTypeEnums = {
    NONE: 0,
    CODE: 1,
    CANNEL: 2,
    ADDRESS: 3,
    IP: 4,
    USER: 5,
    PASSWORD: 6
}


export default function SensorDefinePanel(props: Iprops) {

    const { data } = props

    // 设备运行状态
    const [status, setStatus] = useState<number>(SensorStatus.OFF)
    // 条目编辑状态
    const [editType, setEidtType] = useState<number>(EditTypeEnums.NONE)
    // 最新照片
    const [newPic, setNewPic] = useState<CameraTest>(null)
    // 上传ref
    const uploadRef = useRef(null);
    // 上传文件ref
    const fileRef = useRef(null)
    // 焦距编辑modal
    const [onEditModalOpen, setOnEditModalOpen] = useState<boolean>(false)
    // 焦距
    const [length, setLength] = useState<string>("")


    useEffect(() => {
        if (!data?.id) {
            return
        }
        if (data?.type != SENSOR_TYPE.CAMERA) {
            return
        }
        getCurrentSensorTestPicture(data.id).then(res => {
            setNewPic(res?.data)
        })
        let interval = setInterval(() => {
            getCurrentSensorTestPicture(data.id).then(res => {
                setNewPic(res?.data)
            })
        }, 5000)
        return (() => {
            if (interval) {
                clearInterval(interval)
            }
        })
    }, [data?.id])

    useEffect(() => {
        if (props.data) {
            checkSensorStatus(props.data)
        }
    }, [props.data])

    // 判断设备状态
    const checkSensorStatus = (sensor: Sensor) => {
        if (!sensor?.dataBoxStart || !sensor?.start || !sensor?.period) {
            setStatus(SensorStatus.OFF)
            return
        }
        if (sensor?.lastMeasureTime) {
            let period = sensor.period
            let data = new Date(sensor.lastMeasureTime).getTime()
            let nowTime = Date.now();
            let subValue = nowTime - data
            if (subValue <= 10 * period) {
                setStatus(SensorStatus.ON)
            } else {
                setStatus(SensorStatus.ERROR)
            }
            return
        }
        setStatus(SensorStatus.ERROR)
    }

    const onSensorDataChange = (key: string, value: any) => {
        let updateData = {}
        updateData[key] = value
        updateSensor(data.id, updateData).then(res => {
            data[key] = value
            props.setData({ ...data })
        }).catch(() => {
            TnMessage.error("更新失败！")
        }).finally(() => {
            setEidtType(EditTypeEnums.NONE)
        })
    }

    const onClickTestConnect = () => {
        testCameraConnect(data.id).then(res => {
            if (res.data < 0) {
                message.warning(getWarningMessage(res.data))
            } else {
                message.success("发送测试信号成功，请关注最新拍摄时间查看是否成功拍摄")
            }
        })
    }

    const getWarningMessage = (status: number) => {
        switch (status) {
            case -1:
                return "摄像头不存在";
            case -2:
                return "摄像头未绑定工控机";
            case -3:
                return "工控机不存在";
            case -4:
                return "工控机未配置imei";
            case -5:
                return "工控机未建立连接";
            case -6:
                return "向工控机发送数据失败";
            default:
                break;
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        // 只允许 .json 文件
        if (!file.name.endsWith('.json')) {
            alert('请上传 JSON 文件');
            e.target.value = ''; // 清空 input
            return;
        };
        fileRef.current = file
        setOnEditModalOpen(true)
        e.target.value = ''; // 清空 input，允许上传相同文件再次触发
    }

    const onConfirmEdit = () => {

        const reader = new FileReader();

        reader.onload = (event) => {
            const result = event.target?.result;
            if (typeof result === 'string') {
                try {
                    const json: { [key: string]: any } = JSON.parse(result);
                    if (json["camera_matrix"]) {
                        json["K"] = json["camera_matrix"]
                        delete json["camera_matrix"]
                    }
                    let numberStr = Number(length)?.toFixed(1)
                    console.log('numberStr', numberStr)
                    if(!numberStr || numberStr == "NaN"){
                        message.warning("请输入合法焦距！")
                        return
                    }
                    updateCameraIntrinsic(data.id, numberStr, json).then(res => {
                        if (res.data < 0) {
                            message.warning(getWarningMessage(res.data))
                        } else {
                            message.success("发送同步数据成功")
                        }
                    }).finally(() => {
                        fileRef.current = null
                        setOnEditModalOpen(false)
                    })

                } catch (err) {
                    setOnEditModalOpen(false)
                    console.error('JSON 解析失败:', err);
                }
            } else {
                setOnEditModalOpen(false)
                console.error('读取的内容不是字符串');
            }
        };

        reader.readAsText(fileRef.current); // 读取为字符串
    }

    return (
        <div className="define-main">
            <div className="title">
                设备定义
            </div>
            <div className="device-detail">
                <div className="item">
                    <div className="label">
                        设备名称
                    </div>
                    <div className="value">
                        {data?.name}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        设备编号
                    </div>
                    <div className="value">
                        {!(editType == EditTypeEnums.CODE) ? (
                            <div className="code">
                                {data?.code}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        setEidtType(EditTypeEnums.CODE)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.code || ""}
                                onBlur={(e) => { onSensorDataChange("code", e) }}
                                onPressEnter={(e) => { onSensorDataChange("code", e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        通道号
                    </div>
                    <div className="value">
                        {!(editType == EditTypeEnums.CANNEL) ? (
                            <div className="code">
                                {data?.channel || "未配置"}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        if (data?.start) {
                                            TnMessage.warning("设备运行中，无法编辑")
                                            return
                                        }
                                        // setIsCannelEdit(true)
                                        setEidtType(EditTypeEnums.CANNEL)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.channel?.toString() || ""}
                                onBlur={(e) => { onSensorDataChange("channel", e) }}
                                onPressEnter={(e) => { onSensorDataChange("channel", e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        地址码
                    </div>
                    <div className="value">
                        {!(editType == EditTypeEnums.ADDRESS) ? (
                            <div className="code">
                                {data?.addressCode || "未配置"}
                                <EditSvg className="edit-svg"
                                    onClick={() => {
                                        if (data?.start) {
                                            TnMessage.warning("设备运行中，无法编辑")
                                            return
                                        }
                                        // setIsAddressCodeEdit(true)
                                        setEidtType(EditTypeEnums.ADDRESS)
                                    }}
                                />
                            </div>
                        ) : (
                            <TnInput
                                autoFocus={true}
                                defaultValue={data?.addressCode || ""}
                                onBlur={(e) => { onSensorDataChange("addressCode", e) }}
                                onPressEnter={(e) => { onSensorDataChange("addressCode", e) }}
                            />
                        )}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        设备型号
                    </div>
                    <div className="value">
                        {data?.marking}
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        运行状态
                    </div>
                    <div className="value">
                        <div className={classNames({
                            "status": true,
                            "status-off": status == SensorStatus.OFF,
                            "status-on": status == SensorStatus.ON,
                            "status-error": status == SensorStatus.ERROR,
                        })}>
                        </div>
                    </div>
                </div>
                {data?.type == SENSOR_TYPE.CAMERA && (
                    <>
                        <div className="item">
                            <div className="label">
                                厂商
                            </div>
                            <div className="value">
                                {data?.manufacturer || ""}
                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                                本地ip
                            </div>
                            <div className="value">
                                {!(editType == EditTypeEnums.IP) ? (
                                    <div className="code">
                                        {data?.localIp || "未配置"}
                                        <EditSvg className="edit-svg"
                                            onClick={() => {
                                                setEidtType(EditTypeEnums.IP)
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <TnInput
                                        autoFocus={true}
                                        defaultValue={data?.localIp || ""}
                                        onBlur={(e) => { onSensorDataChange("localIp", e) }}
                                        onPressEnter={(e) => { onSensorDataChange("localIp", e) }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                                登录用户
                            </div>
                            <div className="value">
                                {!(editType == EditTypeEnums.USER) ? (
                                    <div className="code">
                                        {data?.user || "未配置"}
                                        <EditSvg className="edit-svg"
                                            onClick={() => {
                                                setEidtType(EditTypeEnums.USER)
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <TnInput
                                        autoFocus={true}
                                        defaultValue={data?.user || ""}
                                        onBlur={(e) => { onSensorDataChange("user", e) }}
                                        onPressEnter={(e) => { onSensorDataChange("user", e) }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                                登录密码
                            </div>
                            <div className="value">
                                {!(editType == EditTypeEnums.PASSWORD) ? (
                                    <div className="code">
                                        {data?.password || "未配置"}
                                        <EditSvg className="edit-svg"
                                            onClick={() => {
                                                setEidtType(EditTypeEnums.PASSWORD)
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <TnInput
                                        autoFocus={true}
                                        defaultValue={data?.password || ""}
                                        onBlur={(e) => { onSensorDataChange("password", e) }}
                                        onPressEnter={(e) => { onSensorDataChange("password", e) }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                                翻转
                            </div>
                            <div className="value">
                                <Switch
                                    size="small"
                                    value={data?.flipVertical || false}
                                    onChange={(e) => {
                                        onSensorDataChange("flipVertical", e)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="item" style={{ height: 100 }}>
                            <div className="label">
                                <Button size="small" onClick={() => {
                                    onClickTestConnect()
                                }}>连接测试</Button>
                            </div>
                            <div className="value" style={{ height: 100 }}>
                                {newPic?.image && (
                                    <Image
                                        src={"data:image/jpeg;base64," + newPic?.image}
                                        height={100}
                                        width={100}
                                    />
                                )}

                            </div>
                        </div>
                        <div className="item">
                            <div className="label">
                                拍摄时间
                            </div>
                            {newPic?.time && (
                                <div className="value">
                                    {dayjs(newPic?.time).format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                            )}
                        </div>
                        <div className="item">
                            <div className="label">
                                内参
                            </div>
                            <div className="value">
                                <Button
                                    size="small"
                                    type="primary"
                                    onClick={() => {
                                        if (uploadRef.current) {
                                            uploadRef.current.click()
                                        }
                                    }}
                                >
                                    上传内参文件
                                </Button>
                            </div>
                        </div>
                    </>
                )}
                <div className="device-params-list">
                    <div className="list-title">
                        设备参数表
                    </div>
                    <div className="list-item">
                        <div className="first-name">
                            参数名
                        </div>
                        <div className="input-item">
                            初值
                        </div>
                        <div className="input-item">
                            idx
                        </div>
                    </div>
                    {data?.sensorParameters?.map((item, index) => (
                        <DeviceParamItem isRunning={data?.start} key={index} parameter={item} />
                    ))}
                </div>
            </div>
            <input
                type="file"
                ref={uploadRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".json,application/json"
            />
            <Modal
                title="请输入内参文件对应焦距"
                open={onEditModalOpen}
                closeIcon={null}
                onOk={() => {
                    onConfirmEdit()
                }}
                onCancel={() => {
                    fileRef.current = null
                    setOnEditModalOpen(false)
                }}
            >
                <Input
                    value={length}
                    onChange={(e) => {
                        setLength(e.target.value)
                    }}
                />
            </Modal>
        </div>

    )
}